export default __webpack_public_path__ + "8a50c913966989d843434a89bdaac3eb.svg";